export const routesCollectionGuard = 'GET /orders/sorting/machine/d+/map';
export const routesResourceGuard = 'GET /orders/sorting/machine/d+/map/d+';
export const routesRegExpCollectionGuard =
  'GET /orders/sorting/machine/[a-zA-Z0-9- ]+';
export const editRoutesResourceGuard = 'PUT /orders/sorting/machine/d+/map/d+';
export const createRoutesResourceGuard = 'POST /orders/sorting/machine/d+/map';
export const deleteRoutesResourceGuard =
  'DELETE /orders/sorting/machine/d+/map/d+';
